import { ApiError } from "./api";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, "");

function detail(body: unknown) {
  if (!body || typeof body !== "object" || !("detail" in body)) return "";
  const value = (body as { detail?: unknown }).detail;
  if (typeof value === "string") return value;
  if (value && typeof value === "object" && "message" in value) return String((value as { message?: unknown }).message || "");
  return "";
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...init,
    headers: {
      Accept: "application/json",
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  const contentType = response.headers.get("content-type") || "";
  const body = contentType.includes("application/json") ? await response.json().catch(() => null) : await response.text().catch(() => "");
  if (!response.ok) throw new ApiError(detail(body) || `HTTP ${response.status}`, response.status, body);
  return body as T;
}

export type TournamentTimezoneRow = {
  id: string;
  name: string;
  season: number;
  startDate: string;
  endDate: string;
  timezone: string;
  configRevision: number;
};

export const COMMON_EVENT_TIMEZONES = [
  "Europe/Dublin",
  "Europe/London",
  "Europe/Paris",
  "Europe/Zurich",
  "Europe/Madrid",
  "Europe/Warsaw",
  "Asia/Kolkata",
  "Asia/Seoul",
  "Asia/Dubai",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Africa/Johannesburg",
  "Australia/Sydney",
  "Australia/Melbourne",
  "Australia/Perth",
  "Pacific/Auckland",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
];

export const tournamentTimezoneApi = {
  list: (season: number) => request<{ tournaments: TournamentTimezoneRow[]; count: number }>(`/tournament-timezones?season=${season}`),
  save: (tournamentId: string, expectedRevision: number, timezone: string) => request<{ ok: boolean; tournament: TournamentTimezoneRow }>(`/tournaments/${encodeURIComponent(tournamentId)}/timezone`, {
    method: "PUT",
    body: JSON.stringify({ expectedRevision, timezone }),
  }),
};
